export interface LegalSection {
  heading: string
  body: string[]
}

export interface LegalDocument {
  id: 'privacy' | 'terms'
  title: string
  updated: string
  intro: string
  sections: LegalSection[]
}

export const legalDocuments: Record<'privacy' | 'terms', LegalDocument> = {
  privacy: {
    id: 'privacy',
    title: 'Privacy Policy',
    updated: 'Last updated: January 2026',
    intro:
      "Javier's Junk Removal is a local, family-run hauling business serving North County San Diego. We only collect the information we need to quote your job and show up on time.",
    sections: [
      {
        heading: 'Information we collect',
        body: [
          'When you call, text, or message us we may collect your name, phone number, email address, service address, and a description or photos of the items you need removed.',
          'We do not sell, rent, or trade your information to anyone, ever.',
        ],
      },
      {
        heading: 'How we use it',
        body: [
          'Your information is used to give you a quote, schedule the removal, get our truck and trailer to the right address, and follow up about your job.',
          'If you agree, we may occasionally text you about service reminders or seasonal cleanup offers. You can opt out at any time by replying STOP.',
        ],
      },
      {
        heading: 'Photos of your job',
        body: [
          'We sometimes photograph a job site before and after the haul for our own records and marketing. We never include house numbers, faces, or identifying details, and we will not use photos of your property if you ask us not to.',
        ],
      },
      {
        heading: 'Sharing and storage',
        body: [
          'We may share limited details with licensed disposal, recycling, or donation facilities as required to lawfully dispose of your items.',
          'Records are kept only as long as needed for scheduling, warranty, and tax purposes.',
        ],
      },
      {
        heading: 'Your choices',
        body: [
          'You can ask us to correct or delete your information at any time by calling (760) 783-8361. We will confirm the change with you directly.',
        ],
      },
    ],
  },
  terms: {
    id: 'terms',
    title: 'Terms of Service',
    updated: 'Last updated: January 2026',
    intro:
      "These terms cover junk removal, hauling, and cleanout services provided by Javier's Junk Removal throughout North County San Diego.",
    sections: [
      {
        heading: 'Quotes and pricing',
        body: [
          'Phone and text quotes are estimates based on the volume, weight, and access you describe. The final price is confirmed on site before any work begins — you always approve the price before we load anything.',
          'Significant additional items, hazardous materials, or difficult access discovered on arrival may change the price. You are free to decline at that point with no charge.',
        ],
      },
      {
        heading: 'Scheduling and arrival',
        body: [
          'Same-day and next-day service is offered subject to availability. We provide an arrival window and will call or text if traffic, weather, or a prior job affects timing.',
          'Please make sure the items are accessible and that our truck and trailer have room to park.',
        ],
      },
      {
        heading: 'Items we cannot take',
        body: [
          'For safety and legal reasons we cannot remove hazardous waste, including paint, solvents, asbestos, medical waste, fuels, or chemicals. Ask us and we will point you to the right disposal facility.',
        ],
      },
      {
        heading: 'Property and liability',
        body: [
          'We take care of your property and carry out removals professionally. Please remove valuables and anything you intend to keep from the pile before we arrive — once an item is loaded it is considered approved for disposal.',
          'We are not responsible for pre-existing damage, wear, or damage caused by conditions outside our control.',
        ],
      },
      {
        heading: 'Satisfaction promise',
        body: [
          'If you are not satisfied with the job, call us within 48 hours and we will come back and make it right. That is the entire fine print.',
        ],
      },
      {
        heading: 'Payment',
        body: [
          'Payment is due when the job is complete. We accept cash and major digital payment methods. A receipt is provided on request.',
        ],
      },
    ],
  },
}
